import PropTypes from 'prop-types';
import sty from '../../WebCv/WebCv.module.css';

const Certifications = ({ data }) => {

    Certifications.propTypes = {
        data: PropTypes.array.isRequired,
    };

    if (!data || data.length === 0) {
        return <div>資格データがありません</div>;
    }

    return (
        <div>
            <div className={sty['cv__certif-tab']}>
                <div className={sty['cv__certif-content']}>
                    <div className={sty['cv__certif-wrap']}>
                        <table className={sty['cv__certif-table']}>
                            <thead className={sty['cv__certif-head']}>
                                <tr className={sty['cv__certif-cap']}>
                                    <th className={sty['cv__certif-name']}>資格名</th>
                                    <th className={sty['cv__certif-year']}>取得年月</th>
                                </tr>
                            </thead>
                            <tbody className={sty['cv__certif-body']}>
                                {data.map((qualification) => (
                                    <tr className={sty['cv__certif-con']} key={qualification.qualification_id}>
                                        <td className={sty['cv__certif-name']}>{qualification.qualification_name}</td>
                                        <td className={sty['cv__certif-year']}>{qualification.qualification_year}年{qualification.qualification_month}月</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Certifications;